import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Reusable component that fetches a protected image via Bearer header and
 * renders it from a blob URL. Avoids putting JWT in the <img src> query string.
 *
 * Props:
 *   path:    API path (string, starts with /api/... or without /api)
 *   onClick: optional click handler
 *   className, alt: forwarded to <img>
 */
export default function AuthImage({ path, className = "", alt = "", onClick }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let revoked = false;
    let objectUrl = null;
    (async () => {
      try {
        // api baseURL already contains /api — strip leading /api if present
        const relPath = path.startsWith("/api/") ? path.substring(4) : path;
        const r = await api.get(relPath, { responseType: "blob" });
        if (revoked) return;
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      } catch (_e) {
        // ignore (shows broken image fallback)
      }
    })();
    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (!url) {
    return <div className={`bg-slate-100 ${className}`} data-testid="auth-image-loading" />;
  }
  return <img src={url} alt={alt} className={className} onClick={onClick} />;
}
